import React, { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import HeaderCard from 'componentes/generic/HeaderCard.js';

const HeaderStatus = ({ dataSmry, changeStatus }) => {
  useEffect(() => {
    console.log(dataSmry);
  }, []);
  const totalQuejas =
    dataSmry.length > 0 &&
    dataSmry.reduce((acc, item) => {
      return acc + Number(item.quejas);
    }, 0);
  var icons = [
    { status: 'A SALVO LOS DERECHOS', icon: 'check', color: 'success' },
    { status: 'ARCHIVO PROVISIONAL', icon: ['fas', 'archive'], color: 'info' },
    { status: 'CONCILIADA', icon: ['fas', 'check-circle'], color: 'success' },
    {
      status: 'CONCLUIDA',
      icon: ['fas', 'check-double'],
      color: 'success-emphasis'
    },
    {
      status: 'POSIBLE INFRACCION A LA LEY',
      icon: ['fas', 'check-double'],
      color: 'success-emphasis'
    },
    { status: 'EN PROCESO', icon: ['far', 'folder-open'] }
  ];
  return (
    <>
      <Card.Body className="px-xxl-0 pt-4">
        <Row className="g-0">
          <Col>
            <div
              onClick={() => {
                changeStatus(0);
              }}
            >
              <HeaderCard
                data={totalQuejas}
                icon={['fas', 'clipboard-check']}
                amountClassName="text-danger"
                title="TOTAL DE QUEJAS"
                helpText="Quejas Recibidas"
                color="primary"
              ></HeaderCard>
            </div>
          </Col>
          {dataSmry.length > 0 &&
            dataSmry.map(item => (
              <Col key={item.idstatus}>
                <div
                  onClick={() => {
                    changeStatus(item.idstatus);
                  }}
                >
                  <HeaderCard
                    data={item.quejas}
                    amountClassName="text-danger"
                    title={item.status}
                    helpText="Quejas Recibidas"
                    color={icons.find(x => x.status === item.status).color}
                    icon={icons.find(x => x.status === item.status).icon}
                  ></HeaderCard>{' '}
                </div>
              </Col>
            ))}
        </Row>
      </Card.Body>
    </>
  );
};
HeaderStatus.propTypes = {
  dataSmry: PropTypes.array.isRequired,
  changeStatus: PropTypes.func
};
export default HeaderStatus;
